import { useAtomValue } from 'jotai'
import { isRetryPossibleAtom } from '@/src/stores/route-machine/atoms'

interface TradeErrorMessageProps {
  error: Error | string | undefined
}

const tradeErrorMessageGuides = new Map<boolean, string>([
  [
    true,
    'Your funds are still safe in your source wallet. Retry to re-attempt the transfer and start the trade.',
  ],
  [false, ''],
])

export const TradeErrorMessage = ({ error }: TradeErrorMessageProps) => {
  const isRetryPossible = useAtomValue(isRetryPossibleAtom)

  if (!error) return null
  const errorMessage = typeof error === 'string' ? error : error.message
  const errorGuide = tradeErrorMessageGuides.get(isRetryPossible) || ''
  return (
    <span>
      {errorMessage}. {errorGuide}
    </span>
  )
}
